// I campi del "Compila dati" (components/scheda/CompilaDati.jsx): quali sono, come si riempiono e come si mandano
// al server (PUT /immobili/{id}/compila, backend/server.py). Serve solo per gli annunci che l'estrattore non ha
// letto (stato "da_compilare"): quelli letti sono già completi e si correggono da "Modifica".

// campo, etichetta, tipo del campo
export const CAMPI_COMPILA = [
  ['titolo', 'Titolo', 'testo'],
  ['prezzo', 'Prezzo (€)', 'numero'],
  ['superficie', 'Superficie', 'testo'],
  ['locali', 'Locali', 'testo'],
  ['bagni', 'Bagni', 'testo'],
  ['piano', 'Piano', 'testo'],
  ['classe_energetica', 'Classe energetica', 'testo'],
  ['spese_mensili', 'Spese al mese (€)', 'numero'],
  ['ascensore', 'Ascensore', 'si_no'],
  ['tipo_immobile', 'Tipo', 'testo'],
  ['indirizzo', 'Indirizzo', 'testo'],
  ['citta', 'Comune', 'testo'],
  ['zona', 'Zona', 'testo'],
  ['anno_costruzione', 'Anno di costruzione', 'testo'],
  ['condizioni', 'Stato', 'testo'],
  ['riscaldamento', 'Riscaldamento', 'testo'],
  ['descrizione', 'Descrizione', 'area'],
];

const vuoto = (v) => v === null || v === undefined || v === '';

// Quello che c'è già nel form (numeri come testo, ascensore "si"/"no"/"")
export const valoriCompila = (immobile) => Object.fromEntries(CAMPI_COMPILA.map(([campo, , tipo]) => {
  const v = immobile[campo];
  if (tipo === 'si_no') return [campo, v === true ? 'si' : v === false ? 'no' : ''];
  if (tipo === 'numero') return [campo, vuoto(v) ? '' : String(Math.round(Number(v) * 100) / 100).replace('.', ',')];
  return [campo, vuoto(v) ? '' : String(v)];
}));

// Il corpo per il server: numeri come numeri, ascensore "si"/"no", niente campi vuoti
export const corpoCompila = (valori) => {
  const corpo = {};
  CAMPI_COMPILA.forEach(([campo, , tipo]) => {
    const v = typeof valori[campo] === 'string' ? valori[campo].trim() : valori[campo];
    if (vuoto(v)) return;
    if (tipo === 'numero') {
      const n = Number(String(v).replace(/\./g, '').replace(',', '.'));
      if (Number.isFinite(n)) corpo[campo] = n;
    } else corpo[campo] = v;
  });
  return corpo;
};
